<template>
  <div class="userManagement" style="margin-top: 10px;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col >
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane :label="editUserTab" name='editUser'>
            <el-form :model="editUserForm" ref="editUserForm" :rules="rules">
              <el-form-item label="User Name" prop="userName" required >
                <el-input v-model="editUserForm.userName" required :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="User Type" prop="userType" required >
                <el-input v-model="editUserForm.userType" required :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="Email" prop="email" >
                <el-input v-model="editUserForm.email" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('editUserForm')">Sure</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
      name: "changeUserInfo",
      data(){
          return {
            editUserForm:{
              userName:'',
              userType:'',
              organization:'',
              department:'',
              email:'',
            },
            activeName:'editUser',
            editUserTab:'Edit User',
            rules: {
              email: [
                { type: 'email',message:'Please enter the correct email address' ,trigger: ['blur','change'] }
                ],
            },
            disabled:true
          }
      },
      created(){
        this.getUserInfo();
      },
      mounted(){
          this.query();
      },
      methods:{
        getUserInfo:function(){
            let userName = window.sessionStorage.getItem('USER_NAME');
            this.$axios.get('/hlsTS/hlsii/user/getUserInfoByName/' + userName).then((response) => {
              this.editUserForm.userName = response.data.username;
              this.editUserForm.userType = response.data.role.name;
              this.editUserForm.organization = "";
              this.editUserForm.department = "";
              this.editUserForm.email = response.data.email;
            })
        },
        query:function () {},
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$axios.post('/hlsTS/hlsii/user/changeUserInfo/' + this.editUserForm.userName  + '/' + this.editUserForm.organization + '/' + this.editUserForm.department + '/' + this.editUserForm.email)
              .then((response) => {
                if(response.data.success== true){ 
                  this.getUserInfo();
                  this.$message(response.data.message);
                }else{
                  this.$message('Operation failed');
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
      }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .userManagement .el-form-item__label{width:110px;}
  .userManagement .el-form-item__content{margin-left:110px}
  .userManagement .queryFromClass .el-form-item{display: inline-block;}
  .userManagement .el-select{width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/changeUserInfo.vue